var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 47,
    viewBox: "0 0 50 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3177_893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.3401 46.4999C39.4566 46.4999 47.6577 38.2989 47.6577 28.1823C47.6577 18.0658 39.4566 9.86475 29.3401 9.86475C19.2235 9.86475 11.0225 18.0658 11.0225 28.1823C11.0225 38.2989 19.2235 46.4999 29.3401 46.4999Z",
    fill: "#FFA00B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3477 30.6804C16.4951 34.6825 26.4334 38.0497 34.0049 30.6804",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 44.5C35.598 44.5 45 35.098 45 23.5C45 11.902 35.598 2.5 24 2.5C12.402 2.5 3 11.902 3 23.5C3 35.098 12.402 44.5 24 44.5Z",
    stroke: "black",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6876 16.0073C21.6876 19.2534 16.8744 21.881 16.6695 21.9895C16.6154 22.0185 16.555 22.0337 16.4937 22.0337C16.4324 22.0337 16.372 22.0185 16.3179 21.9895C16.113 21.881 11.2998 19.2534 11.2998 16.0073C11.3007 15.245 11.6039 14.5142 12.1429 13.9752C12.6819 13.4362 13.4127 13.133 14.175 13.1321C15.1326 13.1321 15.9711 13.5439 16.4937 14.24C17.0163 13.5439 17.8548 13.1321 18.8124 13.1321C19.5747 13.133 20.3055 13.4362 20.8445 13.9752C21.3835 14.5142 21.6867 15.245 21.6876 16.0073Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7002 16.0073C36.7002 19.2534 31.887 21.881 31.6821 21.9895C31.628 22.0185 31.5677 22.0337 31.5063 22.0337C31.445 22.0337 31.3846 22.0185 31.3306 21.9895C31.1256 21.881 26.3125 19.2534 26.3125 16.0073C26.3133 15.245 26.6165 14.5142 27.1555 13.9752C27.6945 13.4362 28.4253 13.133 29.1876 13.1321C30.1452 13.1321 30.9837 13.5439 31.5063 14.24C32.0289 13.5439 32.8674 13.1321 33.825 13.1321C34.5873 13.133 35.3181 13.4362 35.8571 13.9752C36.3961 14.5142 36.6993 15.245 36.7002 16.0073Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3177_893"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 46,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.30462829dda7a82105ba86ec06719958.svg";
export { ForwardRef as ReactComponent };